import { render, staticRenderFns } from "./DokmanComponentTreeviewOrgElemente.vue?vue&type=template&id=14546628"
import script from "./DokmanComponentTreeviewOrgElemente.vue?vue&type=script&lang=js"
export * from "./DokmanComponentTreeviewOrgElemente.vue?vue&type=script&lang=js"
import style0 from "./DokmanComponentTreeviewOrgElemente.vue?vue&type=style&index=0&id=14546628&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports